import { useQuery } from '@tanstack/react-query';

import decodeJson from '@seccon/shared/utils/decodeJson';
import ApiError from '@seccon/shared/utils/ApiError';

const EMPTY_ARRAY = [];

/**
 * Fetches the contract information
 * @param {} context - react query context
 * @returns {Promise<object>} - CurrentUser information
 */

function fetchOtherPersonnelInCurrentFacility (reportId) {
  return fetch(`/foreignTravel/incident/${ reportId }/getOtherPersonnelInCurrentFacilityDropdownOptions`)
    .then(decodeJson)
    .catch(({ body, status }) => {
      if (status === 404) {
        throw new ApiError('Unable to get the other personnels');
      }
      throw new ApiError(body ? `Error: ${ body }` : 'Unable to retrieve other personnels. Please reload the page and try again');
    });
}

const useOtherPersonnelInCurrentFacility = (reportId, shouldLoad) => {
  const { data } = useQuery({
    queryKey: ['useOtherPersonnelInCurrentFacility', reportId],
    queryFn: () => fetchOtherPersonnelInCurrentFacility(reportId),
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    enabled: !!reportId && shouldLoad
  });

  return data ?? EMPTY_ARRAY;
};

export default useOtherPersonnelInCurrentFacility;
